import styled from "styled-components";
import photo from "assets/images/CW__3558.jpg";
import photoMobile from "assets/images/CW__3568.jpg";
import { fonts } from "styles";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;

  animation-name: appear;
  animation-duration: 500ms;
  animation-timing-function: ease;
  animation-direction: alternate;

  @keyframes appear {
    0% {
      transform: skew(-10deg) translate3d(-10vw, 0px, 0px);
    }
    100% {
      transform: skew(0deg) translate3d(0, 0px, 0px);
    }
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100vh;
  background: url(${photo}) no-repeat center center;
  background-size: cover;
  padding: 124px;

  @media screen and (max-width: 1024px) {
    background: url(${photoMobile}) no-repeat center center;
    background-size: cover;
    align-items: center;
    justify-content: center;
    padding: 48px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 1024px) {
    height: 100%;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 64px;
  line-height: 64px;
  letter-spacing: -2px;
  color: white;
  margin-bottom: 32px;

  @media screen and (max-width: 640px) {
    font-size: 48px;
    line-height: 48px;
  }

  @media screen and (max-width: 414px) {
    font-size: 40px;
    line-height: 40px;
  }

  @media screen and (max-width: 375px) {
    font-size: 32px;
    line-height: 32px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 480px;
  font-size: 16px;
  line-height: 24px;
  color: white;

  p {
    margin-bottom: 133px;

    &:nth-child(2) {
      margin-bottom: 0;
    }

    &.credit {
      display: none;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      line-height: 20px;
    }

    span {
      font-family: ${fonts.BentonSansBold};
    }
  }

  @media screen and (max-width: 1024px) {
    p {
      margin-bottom: 24px;

      &.credit {
        display: block;
        margin-top: 24px;
      }
    }
  }

  @media screen and (max-width: 640px) {
    font-size: 14px;
    line-height: 18px;

    p.credit {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

export const Credit = styled.article`
  width: 100%;
  max-width: 270px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  left: 72px;
  bottom: 124px;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;
